import {
  UPDATE_ID,
  CHANGE_STEP,
  UPDATE_DATASET_VALUE,

  RESET_STATE
} from './constants'


export const changeStep = (step) => {
  return {
    type: CHANGE_STEP,
    step
  }
}

export const prevStep = () => {
  return (dispatch, getState) => {
    const state = getState()
    let currentStep = state.addVehicleModal.get('currentStep')
    const step = --currentStep >= 0 ? currentStep : 0
    dispatch(changeStep(step))
  }
}

export const nextStep = () => {
  return (dispatch, getState) => {
    const state = getState()
    let currentStep = state.addVehicleModal.get('currentStep')
    const step = ++currentStep < 4 ? currentStep : 3
    dispatch(changeStep(step))
  }
}

export const resetState = () => {
  return {
    type: RESET_STATE
  }
}


export const updateDatasetValue = (dataset, name, value) => {
  return {
    type: UPDATE_DATASET_VALUE,
    name, value, dataset
  }
}

export const updateId = (name, id) => {
  return {
    type: UPDATE_ID,
    name, id
  }
}




// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/actions.js